export enum DeviceType {
    Web = 1,
    A = 2,
    // ReSharper disable once InconsistentNaming
    IOS = 3
}